export const ROUTES = {
    login: 'AuthLogin',
    callLog: 'CallLog',
    detailCallLog: 'DetailCallLog',
    whitelist: 'Whitelist',
    urlBinding: 'UrlBinding',
    trunks: 'Trunks',
    notFound: 'NotFound',
}
